<template>
  <div class="wj">
    <section class="poster">
      <div class="poster__content width-wrapper">
        <!-- <img class="poster__outline" src="@/assets/building-outline.png" /> -->

        <img class="poster__letter" src="@/assets/letter-j-big.png" />

        <h1 class="poster__title">
          Kancelaria Adwokacka JKG
          <br />Adwokat <br />Wojciech Jurgowiak
        </h1>

        <div class="poster__bar">
          <a href="#" class="back-button" @click.prevent="$router.push('/')">
            <img src="@/assets/icon-arrow-left.png" /> {{ t("jkg.go.to.page") }} JKG sp. j.
          </a>

          <span style="flex: 1 1 auto;"></span>

          <img class="poster__logo poster__logo--jkg" src="@/assets/jkg-logo.png" />

          <img class="poster__logo poster__logo--ap" src="@/assets/adwokatura-polska.png" />

          <ul class="language-selector__list">
            <li class="language-selector__item language-selector">
              <a href="#" class="" @click.prevent="handleClick">
                {{ language }}
                <img src="@/assets/icon-arrow-down.png" />
              </a>
            </li>
            <li
              class="language-selector__item language-selector"
              id="en"
              @click.prevent="handleLang('en')"
              v-bind:style="{ display: this.display }"
            >
              {{ language === "en" ? "" : "EN" }}
            </li>
            <li
              class="language-selector__item language-selector"
              id="de"
              v-bind:style="{ display: this.display }"
              @click.prevent="handleLang('de')"
            >
              {{ language === "de" ? "" : "DE" }}
            </li>
            <li
              class="language-selector__item language-selector"
              id="pl"
              v-bind:style="{ display: this.display }"
              @click.prevent="handleLang('pl')"
            >
              {{ language === "pl" ? "" : "PL" }}
            </li>
          </ul>
        </div>

        <div class="poster__bar__mobile">
          <div class="poster__top">
            <a href="#" class="back-button" @click.prevent="$router.push('/')">
              <img src="@/assets/icon-arrow-left.png" /> {{ t("jkg.go.to.page") }} JKG sp. j.
            </a>

            <ul class="language-selector__list">
              <li class="language-selector__item language-selector">
                <a href="#" class="" @click.prevent="handleClick">
                  {{ language }}
                  <img src="@/assets/icon-arrow-down.png" />
                </a>
              </li>
              <li
                class="language-selector__item language-selector"
                id="en"
                @click.prevent="handleLang('en')"
                v-bind:style="{ display: this.display }"
              >
                {{ language === "en" ? "" : "EN" }}
              </li>
              <li
                class="language-selector__item language-selector"
                id="de"
                v-bind:style="{ display: this.display }"
                @click.prevent="handleLang('de')"
              >
                {{ language === "de" ? "" : "DE" }}
              </li>
              <li
                class="language-selector__item language-selector"
                id="pl"
                v-bind:style="{ display: this.display }"
                @click.prevent="handleLang('pl')"
              >
                {{ language === "pl" ? "" : "PL" }}
              </li>
            </ul>
          </div>

          <div class="poster__bottom">
            <img class="poster__logo poster__logo--jkg" src="@/assets/jkg-logo.png" />
            <img class="poster__logo poster__logo--ap" src="@/assets/adwokatura-polska.png" />
          </div>
        </div>
      </div>
    </section>

    <section class="bio">
      <div class="bio__content width-wrapper">
        <img class="bio__photo" src="@/assets/photo-wj.png" />

        <div class="bio__text">
          <h1 class="headline">{{ t("jkg.bio.title") }}</h1>

          <p>
            <strong>{{ t("wj.name") }}</strong
            >, {{ t("wj.bio") }}
          </p>
        </div>
      </div>
    </section>

    <!-- <section class="header">
      <div class="header__content width-wrapper">
        <img class="header__logo" src="@/assets/jkg-logo.png" />

        <div class="header__slogan">
          <h1>Kancelaria z tradycjami</h1>

          <p>od ponad 25 lat niezmiennie w sercu Wrocławia.</p>
        </div>
      </div>
    </section>-->

    <!-- <section class="hint">
      <div class="hint__content width-wrapper">
        <p><img src="@/assets/icon-mouse.png" />Przesuń żeby zobaczyć więcej</p>
      </div>
    </section>-->

    <section class="about">
      <div class="about__content width-wrapper">
        <div class="about__column">
          <h1 class="headline">{{ t("jkg.firm.title") }}</h1>

          <p>{{ t("wj.about.firm") }}</p>
        </div>

        <div class="about__column">
          <h1 class="headline">{{ t("jkg.expertise.title") }}</h1>

          <ul>
            <li v-for="item in t('wj.expertise')">- {{ item }}</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="partners">
      <div class="partners__content width-wrapper">
        <h1 class="headline">{{t('wj.coworkers.title')}}</h1>

        <ul class="partners__list">
          <li class="partners__item">
            <div class="partner">
              <img class="partner__photo" src="@/assets/Krzysztof Fila.jpg" />
              <p class="partner__title">{{ t("kf.title") }}</p>
              <p class="partner__name">
                Krzysztof
                <br />Fila
              </p>
              <router-link to="krzysztof-fila" class="partner__link">
                {{ t("jkg.partner.link") }}
                <img src="@/assets/icon-arrow-right.png" />
              </router-link>
            </div>
          </li>

        </ul>
      </div>
    </section>

    <section class="location">
      <div class="location__content width-wrapper">
        <h1 class="headline">{{ t("jkg.location.headline") }}</h1>

        <iframe
          class="location__map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2505.1683239187882!2d17.02926281575523!3d51.1053544795711!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc3e0e634fc93%3A0x99e59e463b4eee0!2sKancelaria%20Adwokacka%20JKG%20Adwokat%20Wojciech%20Jurgowiak!5e0!3m2!1spl!2spl!4v1611662593755!5m2!1spl!2spl"
          width="600"
          height="450"
          frameborder="0"
          style="border:0;"
          allowfullscreen
        ></iframe>
      </div>
    </section>

    <section class="contact">
      <div class="contact__content width-wrapper">
        <div class="contact__box">
          <div class="contact__logos">
            <img class="contact__logo contact__logo--jkg" src="@/assets/jkg-logo.png" />
            <img class="contact__logo contact__logo--ap" src="@/assets/adwokatura-polska.png" />
          </div>

          <p class="contact__name">
            KANCELARIA ADWOKACKA JKG
            <br />ADWOKAT WOJCIECH JURGOWIAK
          </p>

          <p class="contact__address">
            UL. ŚWIDNICKA 36
            <br />50-068 WROCŁAW
          </p>

          <div class="contact-details">
            <img class="contact-details__icon" src="@/assets/icon-phone.png" />
            <p class="contact-details__name">{{ t("jkg.phone") }}</p>
            <p class="contact-details__data">
              +48 / 71 344 20 11
              <br />+48 / 71 372 52 46 <br />+48 / 71 342 56 17
            </p>
          </div>

          <div class="contact-details">
            <img class="contact-details__icon" src="@/assets/icon-mail.png" />
            <p class="contact-details__name">E-mail</p>
            <p class="contact-details__data">
              wjurgowiak@jkg.pl
              <br />wjurgowiak@jkgadwokaci.pl
            </p>
          </div>

          <div class="contact-credit">&copy; {{ getYear() }}</div>
        </div>
      </div>
    </section>

    <section class="footer">
      <div class="footer__content width-wrapper">
        <p>fot. Daniel Grodziński</p>
      </div>
    </section>
  </div>
</template>

<script>
import TranslationService from '@/services/TranslationService.js';

export default {
  name: 'wj',
  props: ['language', 'handleLang'],
  data() {
    return { display: 'none' };
  },

  methods: {
    t(key) {
      return TranslationService.translate(key, this.language);
    },
    handleClick() {
      this.display === 'none' ? (this.display = 'block') : (this.display = 'none');
      console.log('test');
    },
    getYear() {
      const date = new Date();
      return date.getFullYear();
    },
  },

  computed: {},
};
</script>

<style lang="scss">
.wj {
  padding: 40px 0;

  @media screen and (max-width: 670px) {
    padding: 25px 0;
  }

  background-image: url("~@/assets/building-photo.jpg");
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 100% auto;

  .width-wrapper {
    width: 100%;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 30px;

    animation: fadeIn 1s ease-in-out 1;

    @media screen and (max-width: 670px) {
      padding: 0 2%;
    }
  }

  .headline {
    margin-bottom: 60px;
    // text-transform: capitalize;

    font-size: 48px;
    font-weight: 100;

    @media screen and (max-width: 670px) {
      margin-bottom: 10%;
    }
  }

  .poster {
    background-image: url("~@/assets/background-building.png");
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: 100% auto;

    @media screen and (max-width: 670px) {
      background-size: 120% auto;
      background-position: center;
    }

    .width-wrapper {
      position: relative;
      min-height: 1024px;

      @media screen and (max-width: 670px) {
        min-height: 550px;
      }

      &::after {
        content: "";

        position: absolute;
        right: -60px;
        top: -40px;

        width: 2px;
        height: 724px;

        background-color: #214e33;

        animation: slideDown 1s ease-in-out 1;
        animation-delay: 1s;
        animation-fill-mode: both;
      }
    }

    &__letter {
      position: absolute;
      left: -45px;
      top: 150px;

      @media screen and (max-width: 670px) {
        left: -20px;
        width: 36%;
      }
    }

    &__title {
      position: absolute;
      left: 30px;
      top: 46%;
      padding-right: 15%;

      font-size: 48px;
      font-weight: 100;

      transform: translateY(-50%);

      @media screen and (max-width: 670px) {
        top: 90%;
        font-size: 32px;
        padding-right: 10%;
        line-height: 36px;
      }
    }

    &__bar {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 0 30px;

      display: flex;
      align-items: end;

      @media screen and (max-width: 670px) {
        display: none;
      }

      &__mobile {
        @media screen and (max-width: 670px) {
          .poster__top {
            display: flex;
            justify-content: space-between;
            padding: 0 5%;
            position: relative;
          }
          .poster__bottom {
            display: flex;
            margin: 10% auto;
            justify-content: center;

            .poster__logo--jkg {
              width: auto;
              height: 50px;
              margin: 0 4%;
            }

            .poster__logo--ap {
              width: 75px;
              height: 50px;
              margin: 0 4%;
            }
          }
        }

        @media screen and (min-width: 670px) {
          display: none;
        }
      }
    }

    &__logo {
      display: block;

      margin-right: 50px;

      &--jkg {
        width: 159px;
      }

      &--ap {
        width: 91px;
      }
    }

    &__outline {
      display: block;
      width: 100%;
      height: auto;

      animation: sharpen 1s ease-in-out 1;
    }
  }

  .back-button {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    line-height: 24px;
    color: #214e33;
    padding-right: 0;

    @media screen and (max-width: 670px) {
      padding-right: 20%;
    }

    img {
      display: inline-block;
      vertical-align: middle;

      margin-top: -3px;
    }
  }

  .language-selector {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    line-height: 24px;
    color: #214e33;

    a {
      color: #214e33;
      text-decoration: none;
    }

    img {
      display: inline-block;
      vertical-align: middle;

      margin-top: -3px;
    }
  }

  .language-selector__list {
    position: absolute;
    right: -2%;
    top: 0;

    @media screen and (max-width: 670px) {
      right: 5%;
    }
    #en,
    #de,
    #pl {
      display: none;
      color: #214e33;
      margin: 4px 0 0;
      cursor: pointer;
    }
  }

  .bio {
    margin-top: -30px;

    .width-wrapper {
      position: relative;

      &::after {
        content: "";

        position: absolute;
        left: 0;
        top: -529px;

        width: 2px;
        height: 2027px;

        background-color: #214e33;

        @media screen and (max-width: 670px) {
          display: none;
        }
      }
    }

    &__content {
      @media screen and (min-width: 670px) {
        display: flex;
        align-items: center;
      }
    }

    &__photo {
      width: 350px;
      height: auto;
      margin-right: 30px;

      @media screen and (max-width: 670px) {
        width: 100%;
        margin: 25% 0 7%;
      }
    }

    &__text {
      flex: 1 1 auto;

      @media screen and (max-width: 670px) {
        padding: 0 5%;
      }

      p {
        max-width: 634px;

        font-size: 16px;
        font-weight: normal;
        line-height: 1.5;

        strong {
          font-weight: bold;
        }
      }
    }
  }

  .header {
    margin-top: 30px;

    .width-wrapper {
      padding: 0 60px;
    }

    &__content {
      display: flex;
    }

    &__logo {
      display: block;
      width: 284px;
      height: auto;
    }

    &__slogan {
      flex: 1 1 auto;
      align-items: center;
      padding-right: 50px;

      h1 {
        font-size: 56px;
        font-weight: 100;
        text-align: center;
      }

      p {
        margin-top: 4px;

        font-size: 24px;
        font-weight: normal;
        text-align: right;
      }
    }
  }

  .hint {
    margin: 60px 0;

    p {
      opacity: 0.5;

      font-size: 16px;
      text-align: center;
      text-transform: uppercase;
      line-height: 24px;
      color: #214e33;

      img {
        display: inline-block;
        vertical-align: middle;

        margin-top: -3px;
        margin-right: 5px;
      }
    }
  }

  .partners {
    margin-top: 88px;

    .width-wrapper {
      position: relative;

      &::after {
        content: "";

        position: absolute;
        left: 0;
        top: 300px;

        width: 2px;
        height: 2200px;

        background-color: #214e33;
      }

      .headline {
        margin: 0 5% 5% 0;
      }
    }

    &__list {
      @media screen and (max-width: 670px) {
        display: block;

        margin: 0;
      }
      @media screen and (min-width: 670px) {
        display: flex;

        margin: 0 -15px;
      }
    }

    &__item {
      margin: 0 15px;

      @media screen and (max-width: 670px) {
        margin: 0 0 18%;
        flex: 1 1 auto;
      }

    }
  }

  .partner {
    position: relative;
    padding: 32px;

    background-color: #ffffff;

    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

    &__letter {
      position: absolute;
      top: -30px;
      left: 20px;

      width: auto;
      height: 138px;
    }

    &__photo {
      display: block;
      width: auto;
      height: 280px;

      margin-left: auto;
    }

    &__title {
      margin-top: 25px;

      font-size: 16px;
      font-weight: 500;
    }

    &__name {
      margin-top: 5px;

      font-size: 40px;
      font-weight: 100;
      line-height: 1.1em;
    }

    &__link {
      display: block;

      margin-top: 26px;

      font-size: 16px;
      font-weight: bold;
      text-decoration: none;
      text-transform: uppercase;
      color: #214e33;

      img {
        display: inline-block;
        vertical-align: middle;

        margin-top: -3px;
      }
    }
  }

  .about {
    margin-top: 80px;

    @media screen and (max-width: 670px) {
      margin-top: 20%;
    }

    &__content {
      @media screen and (min-width: 670px) {
        display: flex;
      }

      p,
      li {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5em;
      }

      li {
        margin-top: 1.5em;
        text-transform: uppercase;
      }
    }

    &__column {
      max-width: 540px;

      @media screen and (max-width: 670px) {
        padding: 0 5%;
        margin: 20% 0;
      }

      @media screen and (min-width: 670px) {
        &:not(:first-child) {
          margin-left: 30px;
        }
      }
    }
  }

  .location {
    margin-top: 110px;

    @media screen and (max-width: 670px) {
      .headline {
        padding: 0 5%;
      }
    }

    &__map {
      display: block;
      width: 100%;

      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

      @media screen and (max-width: 670px) {
        height: 500px;
      }
    }
  }

  .contact {
    margin-top: 60px;

    &__box {
      max-width: 540px;
      min-height: 826px;
      padding: 76px 54px 50px;
      position: relative;

      @media screen and (min-width: 670px) {
        background-color: #ffffff;
      }

      @media screen and (max-width: 670px) {
        padding: 8% 8% 50%;
      }
    }

    &__logos {
      @media screen and (max-width: 670px) {
        text-align: center;
      }

      @media screen and (min-width: 670px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    &__logo {
      &--jkg {
        width: 228px;
      }

      &--ap {
        width: 91px;
        display: none;

        @media screen and (max-width: 670px) {
          text-align: center;
          display: block;
          margin: 10% auto;
        }
      }
    }

    &__name {
      margin-top: 50px;
      font-size: 24px;
      font-weight: 100;
      text-transform: uppercase;
    }

    &__address {
      margin-top: 5px;
      font-size: 16px;
      line-height: 1.5em;
    }
  }

  .contact-details {
    position: relative;

    margin-top: 30px;
    padding-left: 34px;

    &__icon {
      position: absolute;
      top: 0;
      left: 0;
    }

    &__name {
      font-size: 24px;
      font-weight: 100;
      line-height: 24px;
    }

    &__data {
      font-size: 16px;
      line-height: 1.5em;
    }
  }
  .contact-credit {
    position: absolute;
    bottom: 7%;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    @media screen and (max-width: 670px) {
      position: relative;
      margin-top: 15%;
    }
  }

  .footer {
    margin-top: 75px;

    .width-wrapper {
      position: relative;

      &::after {
        content: "";

        position: absolute;
        right: -60px;
        bottom: 200px;

        width: 2px;
        height: 1033px;

        background-color: #214e33;
      }
    }

    p {
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
